import reducer, { ImageInjectionState } from './reducers';
import ImageInjectionPopover from './components/ImageInjectionPopover';

export default reducer;
export {
  ImageInjectionPopover,
};
export type {
  ImageInjectionState,
};
